import React, {FC} from "react";
import "./OptionButton.css";

interface Props {
    selected: boolean;
    children: React.ReactNode;
    onClick: (event:React.MouseEvent) => void;
}
const OptionButton: FC<Props> = ({selected, children, onClick}) => {
    return <button className={selected ? 'option-button option-button-selected' : 'option-button'} onClick={(evt) => {onClick(evt);}}>{children}</button>
}
export default OptionButton;